import React, { useEffect, useState, useRef } from 'react';
import { ShoppingCartIcon, ChevronDownIcon } from 'lucide-react';
interface HeaderProps {
  cartCount: number;
  onCartClick: () => void;
}
export const Header = ({
  cartCount,
  onCartClick
}: HeaderProps) => {
  const [showCartPreview, setShowCartPreview] = useState(false);
  const cartPreviewRef = useRef<HTMLDivElement>(null);
  // Close cart preview when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (cartPreviewRef.current && !cartPreviewRef.current.contains(event.target as Node)) {
        setShowCartPreview(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <header className="bg-lime-600 text-white shadow-md z-20 relative" data-id="element-174">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-175">
        <div className="flex items-center" data-id="element-176">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vV5eChMTduNXMhtLzhEkuQ/logo.png" alt="খতিয়ান অনুসন্ধান" className="h-10 w-auto mr-3" data-id="element-177" />
          <div data-id="element-178">
            <h1 className="text-lg font-semibold" data-id="element-179">খতিয়ান অনুসন্ধান</h1>
            <p className="text-xs text-gray-100" data-id="element-180">ভূমি রেকর্ড ও জরিপ অধিদপ্তর</p>
          </div>
        </div>
        {/* Desktop Cart Button with Dropdown */}
        <div className="hidden md:block relative" data-id="element-181">
          <button className="flex items-center px-4 py-2 bg-lime-700 hover:bg-lime-800 rounded-md" onClick={onCartClick} onMouseEnter={() => setShowCartPreview(true)} data-id="element-182">
            <ShoppingCartIcon className="h-5 w-5 mr-2" data-id="element-183" />
            <span data-id="element-184">কার্ট দেখুন</span>
            {cartCount > 0 && <span className="ml-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs" data-id="element-185">
                {cartCount}
              </span>}
            <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-186" />
          </button>
          {/* Cart Preview Dropdown */}
          {showCartPreview && <div ref={cartPreviewRef} className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg z-30 text-gray-800" onMouseLeave={() => setShowCartPreview(false)} data-id="element-187">
              <div className="p-3 border-b" data-id="element-188">
                <h3 className="font-medium" data-id="element-189">আপনার কার্ট</h3>
                <p className="text-xs text-gray-500" data-id="element-190">(Your Cart)</p>
              </div>
              {cartCount === 0 ? <div className="p-4 text-center text-gray-500" data-id="element-191">
                  <p data-id="element-192">আপনার কার্ট খালি</p>
                  <p className="text-xs" data-id="element-193">(Your cart is empty)</p>
                </div> : <div className="max-h-64 overflow-y-auto p-3" data-id="element-194">
                  <p className="text-sm mb-2" data-id="element-195">
                    আপনার কার্টে{' '}
                    <span className="font-semibold" data-id="element-196">{cartCount}</span> টি আইটেম
                    আছে
                  </p>
                  <p className="text-xs text-gray-600 mb-3" data-id="element-197">
                    (You have {cartCount} items in your cart)
                  </p>
                  <button onClick={e => {
              e.stopPropagation();
              onCartClick();
              setShowCartPreview(false);
            }} className="w-full py-2 bg-lime-600 hover:bg-lime-700 text-white rounded-md text-sm" data-id="element-198">
                    কার্ট দেখুন
                    <span className="text-xs block" data-id="element-199">(View Cart)</span>
                  </button>
                </div>}
            </div>}
        </div>
      </div>
    </header>;
};